import React, {useMemo, useRef} from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./style.css";

export default function TextEditor(props: any) {
    const quillRef = useRef<ReactQuill>(null);

    const modules = useMemo(() => {
        return {
            toolbar: {
                container: [
                    [{"header": "1"}, {"header": "2"}, {"font": []}],
                    [{size: []}],
                    ["bold", "italic", "underline", "strike", "blockquote"],
                    [{"list": "ordered"}, {"list": "bullet"}, {"indent": "-1"}, {"indent": "+1"}],
                    ["link", "image", "video"],
                    [{"color": []}, {"background": []}],
                    ["clean"]
                ]
            }
        }
    }, []);

    const formats = [
        "header",
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link", "image", "video", "file",
        "align", "color", "background"
    ];

    const handleContentChange = () => {
        props.onChange(quillRef.current!.getEditorContents());
    }

    return (
        <ReactQuill
            ref={quillRef}
            style={{height: "533px"}}
            modules={modules}
            formats={formats}
            preserveWhitespace={true}
            placeholder="내용을 입력해 주세요"
            value={props.content}
            onChange={handleContentChange}/>
    );
}